import { Component } from '@theme/component'

const GridDebuggerConfig = {
  exitTimeout: 2000,
  formFieldTags: ['INPUT', 'TEXTAREA', 'SELECT'],
  key: 'grid-debugger-visible',
  tag: 'grid-debugger'
}

class GridDebugger extends Component {
  #exitTimeout = 0
  #revealFrame = 0

  connectedCallback() {
    super.connectedCallback()
    document.addEventListener('keydown', this.#handleKeydown)
    this.#restoreState()
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.#handleKeydown)
    this.#clearTransitionState()
    super.disconnectedCallback()
  }

  #handleKeydown = (event) => {
    if (!this.#shouldToggleGrid(event)) return
    event.preventDefault()
    const isVisible = this.classList.contains('visible')
    this.#sync(!isVisible)
  }

  #shouldToggleGrid(event) {
    if (event.key !== 'G') return false
    if (!event.shiftKey || event.metaKey || event.ctrlKey || event.altKey) {
      return false
    }
    if (!(event.target instanceof HTMLElement)) return true
    if (GridDebuggerConfig.formFieldTags.includes(event.target.tagName))
      return false
    return !event.target.isContentEditable
  }

  #restoreState() {
    try {
      if (sessionStorage.getItem(GridDebuggerConfig.key) !== 'true') return
      this.#sync(true)
    } catch {
      return
    }
  }

  #sync(visible) {
    this.#clearTransitionState()
    if (visible) this.#showGrid()
    else this.#hideGrid()
    this.#storeState(visible)
  }

  #showGrid() {
    this.classList.remove('exiting')
    if (!this.matches(':popover-open')) this.showPopover()
    this.setAttribute('aria-hidden', 'false')
    this.#revealFrame = window.requestAnimationFrame(() => {
      this.classList.add('visible')
    })
  }

  #hideGrid() {
    const lastColumn = this.querySelector('.grid-debugger__column:last-child')
    this.classList.remove('visible')
    this.classList.add('exiting')
    this.setAttribute('aria-hidden', 'true')
    lastColumn?.addEventListener('transitionend', this.#finishExit, {
      once: true
    })
    this.#exitTimeout = window.setTimeout(
      this.#finishExit,
      GridDebuggerConfig.exitTimeout
    )
  }

  #finishExit = () => {
    const lastColumn = this.querySelector('.grid-debugger__column:last-child')
    window.clearTimeout(this.#exitTimeout)
    lastColumn?.removeEventListener('transitionend', this.#finishExit)
    if (this.classList.contains('visible')) return
    this.classList.remove('exiting')
    if (this.matches(':popover-open')) this.hidePopover()
  }

  #clearTransitionState() {
    const lastColumn = this.querySelector('.grid-debugger__column:last-child')
    window.clearTimeout(this.#exitTimeout)
    window.cancelAnimationFrame(this.#revealFrame)
    lastColumn?.removeEventListener('transitionend', this.#finishExit)
  }

  #storeState(visible) {
    try {
      sessionStorage.setItem(GridDebuggerConfig.key, String(visible))
    } catch {
      return
    }
  }
}

if (!customElements.get(GridDebuggerConfig.tag)) {
  customElements.define(GridDebuggerConfig.tag, GridDebugger)
}
